export default "__VITE_ASSET__Dnsi2h0y__"